// extracted by mini-css-extract-plugin
module.exports = {"question":"qa-module--question--1dUPP"};